import 'angular:locale/data:ar';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "ar";
